import { HelmetProvider, Helmet } from 'react-helmet-async';

export { HelmetProvider };

export function SEO({ title, description, image, url, type = 'website' }) {
  const siteName = 'Znajdownik - Łowca Okazji';
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const desc = description || 'Społeczność łowców okazji. Najlepsze promocje, rabaty i kody zniżkowe. Zarabiaj Zorki!';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta property="og:site_name" content="Znajdownik.pl" />
      <meta property="og:locale" content="pl_PL" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
